import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Container,
  Row } from 'reactstrap';

class DTCSignLoan extends Component {
  render() {
    return (
      <div className="page-signloan">
        <Container fluid>
          <Row>
            <Col xs={12} md={7} lg={8} xl={9}>
              <div className="iframe">
                IFRAME
              </div>
            </Col>
            <Col xs={12} md={5} lg={4} xl={3} className="py-3">
              <Row>
                <Col>
                  <h3 className="mb-2">Sign Credit Loan Document</h3>
                  <p className="mb-3">Borrower must review and e-sign the Credit Loan Document to the left to finalize their loan.</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="border-bottom mb-2 pb-1">Your Approved Loan</h4>
                  <Row className="mb-1" noGutters>
                    <Col xs={8}>
                      <h5 className="mb-0">Amount Financed</h5>
                      <small>Includes the Origination Fee</small>
                    </Col>
                    <Col xs={4}><h5 className="text-primary">$2,500.00</h5></Col>
                  </Row>
                  <Row className="mb-1" noGutters>
                    <Col xs={8}><h5 className="mb-0">Loan Term</h5></Col>
                    <Col xs={4}><h5 className="text-primary">60 Months</h5></Col>
                  </Row>
                  <Row className="mb-1" noGutters>
                    <Col xs={8}><h5 className="mb-0">Interest Rate</h5></Col>
                    <Col xs={4}><h5 className="text-primary">11.99%</h5></Col>
                  </Row>
                  <Row className="mb-1" noGutters>
                    <Col xs={8}><h5 className="mb-0">APR</h5></Col>
                    <Col xs={4}><h5 className="text-primary">24.99%</h5></Col>
                  </Row>
                  <Row className="mb-1" noGutters>
                    <Col xs={8}>
                      <h5 className="mb-0">Origination Fee</h5>
                      <small>Included in monthly payment</small>
                    </Col>
                    <Col xs={4}><h5 className="text-primary">8%</h5></Col>
                  </Row>
                  <Row className="mt-4">
                    <Col>
                      <p><strong className="text-primary">Special Promotion:</strong> No Interest on principal if your loan is paid in full within the first six months</p>
                      <Button tag={Link} to="/" color="secondary" className="w-100 mt-1">eSign Later</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default DTCSignLoan;
